import { useTableContext } from '@edge/spark/io-react-table'
import { isMac } from '@edge/spark/utils'
import { ChevronLeft as ChevronLeftIcon, ChevronRight as ChevronRightIcon } from '@mui/icons-material'
import { Box, IconButton, Stack, Tooltip, Typography } from '@mui/material'

const decrementButtonTooltip = `Previous Page — ${isMac ? 'Command [⌘]' : 'Ctrl [^]'} + Left Arrow [←]`
const incrementButtonTooltip = `Next Page — ${isMac ? 'Command [⌘]' : 'Ctrl [^]'} + Right Arrow [→]`

type Props = {
    incrementActiveRowIndex: () => void
    decrementActiveRowIndex: () => void
    canIncrementActiveRowIndex: boolean
    canDecrementActiveRowIndex: boolean
    pageIndex: number
    totalPages: number
}

export const PaginationControlsPure = ({
    incrementActiveRowIndex,
    decrementActiveRowIndex,
    canIncrementActiveRowIndex,
    canDecrementActiveRowIndex,
    pageIndex,
    totalPages,
}: Props) => {
    return (
        <Stack direction="row">
            <Tooltip title={decrementButtonTooltip}>
                <Box>
                    <IconButton disabled={!canDecrementActiveRowIndex} onClick={decrementActiveRowIndex}>
                        <ChevronLeftIcon />
                    </IconButton>
                </Box>
            </Tooltip>
            <Typography alignSelf="center">
                {pageIndex + 1} of {totalPages}
            </Typography>
            <Tooltip title={incrementButtonTooltip}>
                <Box>
                    <IconButton disabled={!canIncrementActiveRowIndex} onClick={incrementActiveRowIndex}>
                        <ChevronRightIcon />
                    </IconButton>
                </Box>
            </Tooltip>
        </Stack>
    )
}

export const PaginationControls = () => {
    const incrementActiveRowIndex = useTableContext((s) => s.incrementActiveRowByIndex)
    const decrementActiveRowIndex = useTableContext((s) => s.decrementActiveRowByIndex)
    const canIncrementActiveRowIndex = useTableContext((s) => s.getCanIncrementActiveRowByIndex())
    const canDecrementActiveRowIndex = useTableContext((s) => s.getCanDecrementActiveRowByIndex())
    const pageIndex = useTableContext((s) => s.getActiveRowIndex())
    const totalPages = useTableContext((s) => s.getSelectedRowCount())
    return (
        <PaginationControlsPure
            incrementActiveRowIndex={incrementActiveRowIndex}
            decrementActiveRowIndex={decrementActiveRowIndex}
            canIncrementActiveRowIndex={canIncrementActiveRowIndex}
            canDecrementActiveRowIndex={canDecrementActiveRowIndex}
            pageIndex={pageIndex}
            totalPages={totalPages}
        />
    )
}

export type { Props as PaginationControlsProps }
